/** netti at an exact hue, painted for the ground it lands on (never a css orb). */
export const nettiSrc = (hue: number, ground: string) =>
  `/api/brand/netti?hue=${Math.round(hue)}&ground=${encodeURIComponent(ground)}`;
